import React, { useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeExternalLinks from 'rehype-external-links'
import rehypeRaw from 'rehype-raw'

import EmbedVideo from '../elements/embed-video'
import AnchorLink from '../parts/anchor-link'

const Markdown = (props) => {
  useEffect(() => {
    // Accordions
    const accordions = document.querySelectorAll('.markdown-accordion-title');
    if (accordions) {
      accordions.forEach((accordion) => {
        accordion.addEventListener('click', () => {
          accordion.parentElement?.classList.toggle('active');
          const panel = accordion.nextElementSibling;
          if (panel) {
            if (panel.style.maxHeight) {
              accordion.parentElement?.setAttribute('aria-expanded', 'false');
              panel.style.maxHeight = null;
            } else {
              accordion.parentElement?.setAttribute('aria-expanded', 'true');
              panel.style.maxHeight = `${panel.scrollHeight}px`;
            }
          }
        });
      });
    }

    // Image Grid
    const imageGrids = document.querySelectorAll('.markdown-image-grid');
    if (imageGrids) {
      imageGrids.forEach((grid) => {
        const gridChildSpan = grid.querySelector('span');
        if(gridChildSpan) {
          gridChildSpan.outerHTML = gridChildSpan.innerHTML;
        }
        const gridChildP = grid.querySelector('p');
        if(gridChildP) {
          gridChildP.outerHTML = gridChildP.innerHTML;
        }
      });
    }
  }, []);

  if (!props.children || props.children === null) {
    return ''
  }

  let originalcontent = props.children
  let globalData = props.globalData
  let ratingTimeBuffer = props.ratingTimeBuffer ? props.ratingTimeBuffer : 0

  if (originalcontent.data) {
    const textFieldDataKey = Object.keys(originalcontent.data)[0]
    originalcontent = originalcontent.data[textFieldDataKey]
  }

  let formattedContent =
    originalcontent &&
      originalcontent !== null &&
      typeof originalcontent === 'string'
      ? originalcontent.replace(/  +/g, '<br />')
      : ''
  let baseElement = 'span'

  if (props.type === 'longText') {
    formattedContent = originalcontent
      .replace(/<ImageGrid>/g, '<div class="markdown-image-grid">')
      .replace(/<[/]ImageGrid>/g, '</div>')
      .replace(/<Accordion>/g, `<div class="markdown-accordion" aria-expanded="false">`)
      .replace(/<[/]Accordion>/g, '</div>')
      .replace(/<AccordionTitle>/g, `<button type="button" class="markdown-accordion-title">`)
      .replace(/<[/]AccordionTitle>/g, '</button>')
      .replace(/<AccordionContent>/g, `<div class="markdown-accordion-content">`)
      .replace(/<[/]AccordionContent>/g, '</div>')
      .replace(/\*{2}(.*?)\*{2}/g, '<strong>$1</strong>')
      .replace(/\*{1}(.*?)\*{1}/g, '<em>$1</em>')
    baseElement = 'p'
  }

  if (props.type === 'title') {
    formattedContent =
      originalcontent &&
        originalcontent !== null &&
        typeof originalcontent === 'string'
        ? originalcontent.replace(/  +/g, '<br />').replace(/-/g, '\u2011')
        : ''
  }

  if (props.type === 'svg') {
    return (
      <ReactMarkdown
        className={props.className}
        components={{
          strong: 'tspan',
          em: 'a',
          p: ({ children }) => {
            return (
              <tspan
                x={props.xAlign ? props.xAlign : ''}
                dy={props.yAlign ? props.yAlign : ''}
              >
                {children}
              </tspan>
            )
          },
        }}
      >
        {props.children}
      </ReactMarkdown>
    )
  } else {
    return (
      <ReactMarkdown
        className={props.className}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, [rehypeExternalLinks, { target: '_blank', rel: 'noopener noreferrer' }]]}
        components={{
          a: ({ node, children, ...props }) => {
            const linkProps = props
            let linkCustomClass = ''
            if (
              (linkProps.href.includes('youtu.be') ||
                linkProps.href.includes('youtube')) &&
              children[0].type === 'img'
            ) {
              linkCustomClass = 'link-video'
            }

            if (linkProps.href.startsWith('#')) {
              const anchorLink = linkProps.href.substring(1)
              return (
                <AnchorLink
                  to={anchorLink}
                  dataLink={anchorLink}
                  className={'link link-anchor cursor-pointer'}
                >
                  {children}
                </AnchorLink>
              )
            }

            return (
              <a className={`link ${linkCustomClass}`} {...linkProps}>
                {children}
              </a>
            )
          },
          iframe: ({ node, children, ...props }) => {
            return (
              <EmbedVideo
                globalData={globalData}
                ratingTimeBuffer={ratingTimeBuffer}
                {...props}
              />
            )
          },
          h2: ({ node, children, ...props }) => {
            const titleProps = props
            return (
              <h2>
                {titleProps.id && (
                  <span
                    id={titleProps.id}
                    className="absolute -top-24 lg:-top-40"
                  />
                )}
                {children}
              </h2>
            )
          },
          h3: ({ node, children, ...props }) => {
            const titleProps = props
            return (
              <h3>
                {titleProps.id && (
                  <span
                    id={titleProps.id}
                    className="absolute -top-24 lg:-top-40"
                  />
                )}
                {children}
              </h3>
            )
          },
          p: baseElement,
        }}
      >
        {formattedContent}
      </ReactMarkdown>
    )
  }
}

export default Markdown
